import Localizer from "./index";
import { EventEmitter as thdEventEmitter } from "./eventEmitter/eventEmitter";

// Auto-initialize
Localizer.localize()
  .then()
  .catch((e) => console.error("Localization initialization failed:", e));

// Named exports to ensure they're accessible as properties
export { Localizer };
export { thdEventEmitter };

// Default export to maintain compatibility with imports
const autoInitExports = {
  Localizer,
  thdEventEmitter
};

// This ensures the file can be both imported as a module and used via UMD/AMD
export default autoInitExports;
